import { Component, inject } from '@angular/core';
import { DialogService } from 'src/app/dialog/services/dialog.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: false,
})
export class FooterComponent {
  private readonly dialogService = inject(DialogService);

  private readonly appVersion = environment.appVersion;

  private readonly latestReleaseNotes = `App Version: ${this.appVersion}`;

  showAppInfo() {
    const currentYear = new Date().getFullYear();
    this.dialogService.alert(
      this.latestReleaseNotes,
      `© ${currentYear} - STSL - All rights reserved`
    );
  }
}
